<template>
  <div id="loader" v-show="carregando">
    <ring-loader color="#5bc0de"/>
  </div>
</template>

<script>
import RingLoader from "vue-spinner/src/RingLoader";
export default {
  props: {
    carregando: {
      required: true,
      type: Boolean
    }
  },
  components: {
    RingLoader
  }
};
</script>

<style>
#loader {
  position: fixed;
  padding: 2rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #383232eb;
  border-radius: 3px;
}
</style>
